import { useState, useCallback, useEffect, useReducer } from "react";
import { memoryTokenStore } from "utils/memoryTokenStore";
import tokenReducer from "../reducers/tokenReducer";
import { logoutUser } from "api/coreApi";

export function useMemoryAuth() {
  const [token, dispatch] = useReducer(tokenReducer, null);
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    const unsubscribe = memoryTokenStore.subscribe((newToken) => {
      if (newToken) {
        dispatch({ type: "changed", token: newToken });
      } else {
        dispatch({ type: "deleted", token: null });
      }

      setBootstrapped(true);
    });

    return unsubscribe;
  }, []);

  const login = useCallback((jwt: string) => {
    memoryTokenStore.setToken(jwt);
  }, []);

  const logout = useCallback(async () => {
    try {
      await logoutUser(); // wait for server to destroy cookie
    } catch (e) {
      console.error("Logout failed", e);
    } finally {
      memoryTokenStore.setToken(null);
    }
  }, []);

  const isAuthenticated = Boolean(token);
  const status: "loading" | "authenticated" | "unauthenticated" = !bootstrapped
    ? "loading"
    : token
      ? "authenticated"
      : "unauthenticated";

  return {
    token,
    login,
    logout,
    isAuthenticated,
    status,
  };
}
